import { NotificationContext } from '@context/Notification';
import { useContext } from 'react';

export default function useNotificationContext() {
  return useContext(NotificationContext);
}
